import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map } from "rxjs/operators";
import { CustomerMappingResponse } from '../_model/customer-mapping-response/customer-mapping-response';
import { MappingPropertiesResponse } from "../_model/customer-mapping-response/mapping-properties-response";
import { UserService } from './user.service';
import { FormGroup } from '@angular/forms';
import { FilterDto } from '../_model/filterDto';
import { PageParams } from "././table/page-params";
import { MultipleFilterProperty } from '../_model/multiple-filter-property';

@Injectable({
  providedIn: 'root'
})
export class CustomerMappingService {

  customerMappingUrl = '/customer-mapping';
  mappingPropsUrl = '/mapping-properties';
  filterUrl = '/filter';
  filterDto: Array<FilterDto> = [];

  constructor(private http: HttpClient, private userService: UserService) {
  }

getMappingProperties(): Observable<MappingPropertiesResponse> {
  return this.http.get<MappingPropertiesResponse>(this.userService.getClientBaseNewUrl() + this.mappingPropsUrl)
    .pipe(map(response => {
      // Create a new object to hold the converted properties
      const convertedClientProperties: { [key: string]: any; } = {};
      const clientProps = response.data.clientProperties as any;
      if (clientProps) {
        Object.keys(clientProps).forEach(key => {
          const val = clientProps[key];
          convertedClientProperties[key] = (val && typeof val === 'object') ? val : { displayName: val };
        });
      }
      response.data.clientProperties = this.createPropertiesMap(convertedClientProperties);

      // Repeat the process for rentokilProperties
      const convertedRentokilProperties: { [key: string]: any; } = {};
      const rentokilProps = response.data.rentokilProperties as any;
      if (rentokilProps) {
        Object.keys(rentokilProps).forEach(key => {
          const val = rentokilProps[key];
          convertedRentokilProperties[key] = (val && typeof val === 'object') ? val : { displayName: val };
        });
      }
      response.data.rentokilProperties = this.createPropertiesMap(convertedRentokilProperties);

      return response;
    }));
}

  getCustomerMapping(page: number,size: number): Observable<CustomerMappingResponse> {
    const pageParams = PageParams.getPageParams(page, size);
    return this.http.get<CustomerMappingResponse>(this.userService.getClientBaseNewUrl() + this.customerMappingUrl, { params: pageParams });
  }

  createCustomerMapping(body: object): Observable<any> {
    return this.http.post<any>(this.userService.getClientBaseNewUrl() + this.customerMappingUrl, body);
  }

  filterCustomerMapping(filters: FormGroup, page: number, size: number): Observable<CustomerMappingResponse> {
    const pageParams = PageParams.getPageParams(page, size);
    if ((filters && (typeof filters.value.multipleFilterarray != "undefined"
      && filters.value.multipleFilterarray != null
      && filters.value.multipleFilterarray.length != null
      && filters.value.multipleFilterarray.length > 0))) {
      let url = this.userService.getClientBaseNewUrl() + this.customerMappingUrl + this.filterUrl;
      this.createBody(filters);
      let body = {
        filterListDTO: this.filterDto
      };
      this.filterDto = [];
      return this.http.post<CustomerMappingResponse>(url, body, { params: pageParams });
    }
      
    return new Observable<CustomerMappingResponse>();

  }




  private createBody(filters: FormGroup) {
    //console.log(filters.value)
    filters.value.multipleFilterarray.forEach((element: MultipleFilterProperty) => {
      let dto = new FilterDto();


        dto.property = element.column;
        dto.value = element.value;
      

      this.filterDto.push(dto);
    });
  }


  updateCustomerMapping(body: object): Observable<any> {
    return this.http.put<any>(this.userService.getClientBaseNewUrl() + this.customerMappingUrl, body);
  }

  deleteCustomerMapping(id: number): Observable<any> {
    return this.http.delete<any>(this.userService.getBaseUrl() + this.userService.getFmSystemUrl() + this.customerMappingUrl + '/id/' + id);
  }

  private createPropertiesMap(properties: { [key: string]: any }) {
    const map: Map<string, any> = new Map();
    if (properties) {
      Object.keys(properties).forEach(key => {
        map.set(key, properties[key]);
      });
    }
    return map;
  }
}
